import SlsWorkFlowUsuarioClient from '@/api/SistemaDKP/Workflow/sis-workflow-usuario.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSWorkFlowUsuarioService {
  constructor() {
    this.client = new SlsWorkFlowUsuarioClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os workflow usuario');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Workflow Usuario');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Workflow Usuario');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Workflow Usuario');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.client.destroy(body);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Workflow Usuario');
    }
  }
}
